import React, { useState, useEffect } from 'react';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import '../styling/sidebar.css';
import '../styling/expensepop.css';
import GetUser from '../services/get-user';

import ToggleButton from '@mui/material/ToggleButton';
import { ReactComponent as EditPic }  from '../assets/editpencil.svg';
import { CircularProgress } from '@material-ui/core';

export default function ECPopup(props) {
  const [name, setName] = useState(props.keydata.name);
  const [amount, setAmount] = useState(props.keydata.amount);
  const [expenseID, setexpenseID] = useState(props.keydata._id);
  const [site, setSite] = useState(props.keydata.site);
  const [note, setNote] = useState(props.keydata.note);
  const [usedate, setUseDate] = useState(new Date(props.keydata.realDate));
  const [category, setCategory] = useState(props.keydata.category);
  const [editState, setEditState] = useState(false);
  const [copies, setCopies] = useState(1);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const user= GetUser();

  function validateForm() {
    return name.length > 0 && parseInt(amount) >= 0 && copies <= 5 && copies >= 1;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try{
      //'http://localhost:8080/income/add_income'
      //return axios.post('http://localhost:8080/expense/remove_expense', {
      return axios.post('https://sotira-back-test.herokuapp.com/expense/copy_expense', {
        userID: user.userID,
        expenseID: expenseID,
        copies: copies,
      }).then(response=>{
        sessionStorage.setItem("option", 'expense');
        setLoading(false);
        props.closeDuplicateModel(false);
        props.setReloadTableData((prevState)=>!prevState);
        props.setReloadAPI((prevState)=>!prevState);
      });
    } catch(e:any){
      setLoading(false)
      alert(e.message);
    }
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="name" className="form-group required">
        <Form.Label className="control-label"> Expense Name </Form.Label>
        <Form.Control
          autoFocus
          type="name"
          value={name}
          readOnly
        />
      </Form.Group>
        <div>
      <Form.Group controlId="date">
        <Form.Label> Date Purchased </Form.Label>
        <DatePicker readOnly selected={usedate} onChange={(date) => setUseDate(date)} showTimeSelect dateFormate="Pp" className="date-picker-input"/>
      </Form.Group>

      <Form.Group controlId="amount" className="form-group required">
        <Form.Label className="control-label"> Amount $ </Form.Label>
        <div className="d-flex">
        <span className="font-currency mr-2 mt-1">$</span>
        <Form.Control
          autoFocus
          step={.01}
          value={amount}
          readOnly
        />
        </div>
      </Form.Group>

      <Form.Group controlId="site">
        <Form.Label className="control-label"> Purchased From  </Form.Label>
        <Form.Control
          autoFocus
          type="site"
          value={site}
          readOnly
        />
      </Form.Group>

      <Form.Group controlId="cat">
        <Form.Label> Category </Form.Label>
        <input readOnly className="form-control" type="text" defaultValue={category} list="categories" onChange={(e) => setCategory(e.target.value)} />
        <datalist id="categories">
          {props.categories.map((item, key) =>
            <option key={key} value={item}/>
          )}
        </datalist>
      </Form.Group>

      <Form.Group controlId="note">
        <Form.Label> Note </Form.Label>
        <Form.Control
          autoFocus
          type="note"
          value={note}
          readOnly
        />
      </Form.Group>
      </div>
      <Form.Group controlId="note">
        <Form.Label> Duplicate expense (max 5 duplications) </Form.Label>
        <Form.Control
          as="select"
          autoFocus
          type="copies"
          value={copies}
          onChange={(e) => setCopies(Number(e.target.value))}
        >
          <option value={1}>1</option>
          <option value={2}>2</option>
          <option value={3}>3</option>
          <option value={4}>4</option>
          <option value={5}>5</option>
        </Form.Control>
      </Form.Group>

      <Button block size="sm" type="submit" disabled={!validateForm()}>
      {loading ?
        <><CircularProgress className="file-loader mr-3" />Copying</>
        : `Duplicate ${copies} time(s)`
      }   
      </Button>
    </Form>
  );
};
